<template>
  <div class="tire-category-search">
    <div class="search-controls">
      <select 
        class="fleet-select filter" 
        v-model="selectedFleet"
        @change="handleFleetChange"
      >
        <option 
          v-for="fleet in fleetList" 
          :key="fleet" 
          :value="fleet"
        >
          {{ fleet }}
        </option>
      </select>
      
      <input 
        class="license-plate-input search-spz" 
        type="text" 
        v-model="licensePlate"
        @change="handleLicensePlateChange"
        @click="handleClearIfCtrlPressed"
        placeholder="RZ vozidla" 
      />
      
      <button 
        class="tire-search-btn search-btn" 
        @click.prevent="handleCategorySearch"
        :disabled="!isValidSearch"
      >
        Hledat pneu kategorii
      </button>
    </div>
    
    <div v-if="!isValidSearch" class="validation-message"> Vyplňte RZ vozidla (minimálně 5 znaků)
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'

export default {
  name: 'TireCategorySearch',
  props: {
    fleetList: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  emits: ['search'],

  setup(props, { emit }) {
    // Reactive data - convert from data() function
    const selectedFleet = ref(props.fleetList[0] || 'Arval') // Default to first fleet
    const licensePlate = ref('')

    // Computed properties - convert from computed object
    const isValidSearch = computed(() => {
      return selectedFleet.value &&
             licensePlate.value?.length >= 5
    })

    // Methods - convert to regular functions
    const handleFleetChange = () => {
      // Fleet selection changed
      emit('fleet-change', selectedFleet.value)
    }

    const handleLicensePlateChange = () => {
      // License plate input changed
      emit('license-plate-change', licensePlate.value)
    }

    const handleCategorySearch = () => {
      if (!isValidSearch.value) {
        console.warn('Invalid search criteria')
        return
      }

      const searchData = {
        spz: licensePlate.value.toUpperCase(),
        flotila: selectedFleet.value
      }

      console.log('Searching tire category:', searchData)
      emit('search', searchData)
    }

    const handleClearIfCtrlPressed = (event) => {
      if (event.ctrlKey) {
        licensePlate.value = ''
        console.log('License plate cleared via Ctrl+click')
      }
    }

    // Public methods that can be called by parent
    const clearInputs = () => {
      licensePlate.value = ''
    }

    const setFleet = (fleet) => {
      if (props.fleetList.includes(fleet)) {
        selectedFleet.value = fleet
      }
    }

    // Watchers - convert from watch object
    watch(() => props.fleetList, (newFleetList) => {
      if (newFleetList.length > 0 && !newFleetList.includes(selectedFleet.value)) {
        selectedFleet.value = newFleetList[0]
      }
    }, { immediate: true })

    return {
      selectedFleet,
      licensePlate,
      isValidSearch,
      handleFleetChange,
      handleLicensePlateChange,
      handleCategorySearch,
      handleClearIfCtrlPressed,
      clearInputs,
      setFleet
    }
  }
}
</script>

<style scoped>

.search-label {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
}

.search-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.fleet-select,
.license-plate-input {
  border-radius: 5px;
  border: 1px solid #555;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 7px;
  color: #fff;
  background-color: #444;
  font-size: 14px;
}

.fleet-select {
  min-width: 150px;
  width: 180px;
}

.license-plate-input {
  width: 120px;
  min-width: 100px;
}

.fleet-select:hover,
.license-plate-input:hover,
.fleet-select:focus,
.license-plate-input:focus {
  border-color: #8bc3ff;
  box-shadow: 0 0 0 2px rgba(139, 195, 255, 0.25);
}

.search-controls button {
  border-radius: 5px;
  color: white;
  transition: background-color 0.3s;
  border: none;
  cursor: pointer;
  padding: 7px 20px;
  font-size: 14px;
  white-space: nowrap;
}

.search-btn:hover {
    background-color: #0056b3;
}
.search-btn {
  background-color: #007bff;
}

.search-btn:hover {
  background-color: #0056b3;
}


.validation-message {
    position: relative;
    height: fit-content;
    color: #ffc107;
    margin-left: 147px;
    margin-top: -47px;
    width: 100%;
    font-size: 10px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .validation-message {
    margin-left: -180px;
  }
  
  .fleet-select,
  .license-plate-input {
    width: 100%;
    min-width: auto;
  }
  
}
</style>